import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppService } from './app.service';
import { API } from '../constants';

export interface SaveGroupPreferencePayload {
  userId: number | string;
  organizationId: number | string;
  channelName: string;
  // Extra fields are kept: the seed sends the hero panel's full group option, same as the panel.
  groups: { id: number; name: string; group_type: string; [key: string]: any }[];
}

// DataSource layer for the shared "grouping preferences" HTTP contract already used by the
// AI-agent hero panel (ai-agent.component.ts) - reused here to seed/read a fan's preferred group
// for signup/login redirect purposes. No business logic lives here, only request building.
@Injectable({
  providedIn: 'root',
})
export class GroupPreferenceApiService {
  constructor(private appService: AppService) {}

  saveGroupPreference(payload: SaveGroupPreferencePayload): Observable<any> {
    const url = `${API.AI_FAN_AGENT_SAVE_GROUPING}?NOLOADER`;
    const formData = new FormData();
    formData.append('user_id', String(payload.userId));
    formData.append('organization_id', String(payload.organizationId));
    formData.append('channel_name', payload.channelName || '');
    formData.append('question_type', 'group');
    formData.append('question_text', 'Signup group preference');
    formData.append('selected_groups', JSON.stringify(payload.groups));
    // postBase1Request returns undefined (not an Observable) when offline - fall back to a safe
    // no-op observable so callers can always .pipe()/.subscribe() without checking for that case.
    return this.appService.postBase1Request(url, formData) || of(null);
  }

  fetchGroupingPreferences(userId: number | string, organizationId: number | string, channelName: string): Observable<any> {
    const url = `${API.AI_FAN_AGENT_GROUPING_QUESTIONS}?NOLOADER`;
    const formData = new FormData();
    formData.append('user_id', String(userId));
    formData.append('organization_id', String(organizationId));
    formData.append('channel_name', channelName || '');
    return this.appService.postBase1Request(url, formData) || of(null);
  }
}
